import { CoreUsersCurrentName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getCurrentUser } from '@api';
import { updateUserReferences } from '../_idMap/actions';

export const coreUsersCurrentGetAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [
			(user) =>
				updateUserReferences([
					{
						email: user.email,
						firstName: user.firstName,
						lastName: user.lastName,
						userId: user.id
					}
				])
		]
	},
	name: CoreUsersCurrentName,
	receive: true,
	request: false,
	requestHandler: getCurrentUser,
	retainDataOnRequest: true
});
